/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { BBDocCreateRequest } from '../types/BBDocCreate';
import type { BBDocCreateResponse } from '../types/BBDocCreate';

export type BbDocsCreateRequest = BBDocCreateRequest;
export type BbDocsCreateResponse = BBDocCreateResponse;

export type BbDocsCreateQuery = {};

/**
 * POST /dmx-server/bb_docs/
 *
 * ```yaml
 * operationId: bb_docs_create
 * tags:
 *   - bb_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/BBDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/BBDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/BBDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/BBDocCreate'
 *     description: ''
 * ```
 */
export const bbDocsCreateOperation = (rest?: BbDocsCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/bb_docs/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/bb_docs/' };
  };

/**
 * POST /dmx-server/bb_docs/
 *
 * ```yaml
 * operationId: bb_docs_create
 * tags:
 *   - bb_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/BBDocCreate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/BBDocCreate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/BBDocCreate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '201':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/BBDocCreate'
 *     description: ''
 * ```
 */
export const bbDocsCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: BbDocsCreateQuery;
  request: BBDocCreateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<BBDocCreateResponse>> => {
  const operation = bbDocsCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
